<template>
    <div class="container h-100">
        <div class="img">
            <img src="../assets/logo.jpg" alt="" class="d-block img-logo">
        </div>
        <div class="row h-100 align-items-center">
            <div class="col-12 col-md-6 offset-md-3">
                <div class="card shadow sm">
                    <div class="card-body">
                        <h1 class="text-center">Login</h1>
                        <hr />
                        <form action="javascript:void(0)" method="post">
                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label">Email</label>
                                <input type="email" v-model="auth.email" name="email" id="email" class="form-control">
                            </div>
                            <div class="mb-3">
                                <label for="exampleInputPassword1" class="form-label">Password</label>
                                <input type="password" v-model="auth.password" name="password" id="password"
                                    class="form-control">
                            </div>
                            <div class="d-flex justify-content-between">
                                <button type="submit" :disabled="processing" @click="login()" class="btn btn-primary mb-3 ">
                                    {{ processing ? "Please wait" : "Login" }}
                                </button>
                                <router-link :to="{ name: 'recovery-account'}">forgot password?</router-link>
                            </div>                            
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import * as authservice from '../services/auth_service'

export default {
    name:"login",
    data(){
        return {
            auth:{
                email:"",
                password:""
            },
            processing:false
        }
    },
    methods:{  
        
        async login() {
            try {
               this.processing = true;
                await authservice.sanctumCsrfCookie();
                const auth = await authservice.auth(this.auth);
                const token = auth.data.accessToken;    
                const user = auth.data.user;            

                if (auth.data.success) {                   
                    this.addTokens(token,user)
                    this.$router.push({ name: 'dashboard' });
                }else {
                    this.makeToast('Warning', 'Invalid credentials', 'warning');
                    this.processing = false;
                }             

            } catch (error) {
                console.log(error)
            }
                
        },

        addTokens(token, user) {
            localStorage.setItem('accessToken', JSON.stringify(token))
            localStorage.setItem('refreshToken', JSON.stringify(token))
            localStorage.setItem('user', JSON.stringify(user))
        },
        
        makeToast(title, text, type) {
            this.toastCount++
            this.$bvToast.toast(text, {
                title: title,
                variant: type,
                autoHideDelay: 2000,
                appendToast: true
            })
        },
         
    }
}
</script>
